<template>
  <div>
    <el-table
      style="width: 100%"
      :data="tableData"
      row-key="platform"
      :expand-row-keys="expand_rows"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="demo-table-expand">
<!--            策略配置-->
            <el-table :data="props.row.levels" :show-header="true" border style="width: 100%">
              <el-table-column label="梯度配置" prop="trigger_mode">
                <template slot-scope="{row}">
                  <div style="display: flex; padding: 0 10px; flex-flow: column;">
                    <span style="padding-bottom: 5px">梯度：{{ row.rate_level }}%(k×{{ row.k_limit }})</span>
                    <span style="padding-bottom: 5px">倍数：{{ row.order_lever }}</span>
                    <span style="padding-bottom: 5px">金额：{{ row.order_amount }}U</span>
                    <span style="padding-bottom: 5px">止盈：{{ row.profit_percentage }}%(<span style="color: #07bd54">{{computeIncome(row)}}</span>)</span>
                    <span style="padding-bottom: 5px">止损：{{ row.loss_percentage > 0 ? row.loss_percentage+'%' : '' }}(<span style="color: #f56c6c">{{computeLoss(row)}}</span>)</span>
                    <span style="padding-bottom: 5px">最低交易额：{{ computeTradeVol(row) }}</span>
<!--                    <span style="padding-bottom: 5px">是否启用：{{ row.is_enable }}</span>-->
<!--                    <span style="padding-bottom: 5px">仅通知不下单：{{ row.is_only_notice }}</span>-->
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="启用" width="50px">
                <template slot-scope="{row}">
                  <el-switch style="zoom:0.7;" :value="row.is_enable === 1" @change="triggerLevelEnable(row)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="仅通知" width="65px">
                <template slot-scope="{row}">
                  <el-switch style="zoom:0.7;" :value="row.is_only_notice === 1" @change="triggerLevelOnlyNoticeEnable(row)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50px">
                <template slot-scope="{row}">
                  <el-button type="danger" size="mini" circle @click="triggerConfigDel(row.id)">
                    <i class="el-icon-delete-solid"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="平台" prop="platform">
        <template slot-scope="props">
          <div style="display: flex; align-items: center">
            <div style="margin-left: -10px;">
              <img style="margin-right: 2px" width="12px" height="12px" :src="platformIcon(props.row.platform)">
            </div>
            <div>
              {{props.row.platform}} <span style="color: red; font-size: 20px" v-show="props.row.levels.length > 0"> •</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="35">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" circle @click="tradeConfigSave(row)">
            <i class="el-icon-edit-outline"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <globbing-config-save ref="tradeForm" :order-direction="orderDirection" @successfn="getTradeConfigList"></globbing-config-save>
  </div>
</template>

<script>
import api from '@/api/api'
import { getPlatformIcon } from '@/utils/platformIcon'
import GlobbingConfigSave from '@/components/platformGlobbingKlineConfig/GlobbingConfigSave.vue'

export default {
  name: 'GlobbingConfigs',
  components: {
    GlobbingConfigSave
  },
  props: {
    orderDirection: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      value: true,
      instId: '',
      trigger_mode: '',
      tableData: [],
      expand_rows: []
    }
  },
  created () {
    this.getTradeConfigList()
  },
  methods: {
    computeTradeVol (item) {
      if (parseInt(item.min_trade_vol) >= 10000) {
        return parseFloat(parseInt(item.min_trade_vol)/10000).toFixed(2) + '亿U'
      }
      return item.min_trade_vol + '万U'
    },
    computeIncome (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.profit_percentage)) {
        return `${item.order_lever * item.order_amount * item.profit_percentage * 0.01}`
      }
      return ''
    },
    computeLoss (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.loss_percentage)) {
        if (parseFloat(item.order_lever) * parseFloat(item.loss_percentage) >= 100) {
          return '已超爆仓阈值！'
        }
        return `${item.order_lever * item.order_amount * item.loss_percentage * 0.01}`
      }
      return ''
    },
    platformIcon (platform) {
      return getPlatformIcon(platform)
    },
    // 货币配置列表
    getTradeConfigList () {
      this.$loading({ body: true })
      api.globbingKlineConfigList({
        order_direction: this.orderDirection
      }).then(res => {
        if (res.code === 0) {
          this.tableData = res?.data || []
        } else {
          this.$message.error({
            message: '获取配置失败',
            customClass: 'phone-custom-message'
          })
        }
      }).catch(res => {
        this.$message.error({
          message: '获取配置失败',
          customClass: 'phone-custom-message'
        })
      }).finally(_ => {
        this.$loading({}).close()
      })
    },
    // 货币配置删除
    triggerConfigDel (id) {
      this.$confirm('删除不可恢复！', '确认删除？', {
        type: 'warning',
        customClass: 'mobile-message-box'
      })
        .then(_ => {
          api.globbingConfigDel({ id: id }).then(res => {
            if (res.code === 0) {
              this.$message.success({
                message: '操作成功',
                customClass: 'phone-custom-message'
              })
            } else {
              this.$message.error({
                message: '操作失败',
                customClass: 'phone-custom-message'
              })
            }
          }).catch(res => {
            this.$message.error({
              message: '操作失败',
              customClass: 'phone-custom-message'
            })
          }).finally(() => {
            this.getTradeConfigList()
          })
        })
        .catch(_ => {})
    },
    // 货币配置提交
    tradeConfigSave (item) {
      const editReport = this.$refs.tradeForm
      editReport.show(item)
    },
    triggerLevelEnable (row) {
      let enable = 1 // 默认开启
      if (parseInt(row.is_enable) === 1) { // 当前是开启就修改为关闭
        enable = 0
      }
      api.globbingKlineConfigEnable({ id: row.id, is_enable: enable }).then(res => {
        if (res.code === 0) {
          this.$message.success({
            message: '操作成功',
            customClass: 'phone-custom-message'
          })
        } else {
          this.$message.error({
            message: '操作失败',
            customClass: 'phone-custom-message'
          })
        }
      }).catch(res => {
        this.$message.error({
          message: '操作失败',
          customClass: 'phone-custom-message'
        })
      }).finally(() => {
        this.getTradeConfigList()
      })
    },
    triggerLevelOnlyNoticeEnable (row) {
      let enable = 1 // 默认开启
      if (parseInt(row.is_only_notice) === 1) { // 当前是开启就修改为关闭
        enable = 0
      }
      api.globbingKlineConfigNoticeEnable({ id: row.id, is_enable: enable }).then(res => {
        if (res.code === 0) {
          this.$message.success({
            message: '操作成功',
            customClass: 'phone-custom-message'
          })
        } else {
          this.$message.error({
            message: '操作失败',
            customClass: 'phone-custom-message'
          })
        }
      }).catch(res => {
        this.$message.error({
          message: '操作失败',
          customClass: 'phone-custom-message'
        })
      }).finally(() => {
        this.getTradeConfigList()
      })
    }
  }
}
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
    padding: 0 5%;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }
  ::v-deep .el-message-box {
    width: 250px !important;
  }
  .el-switch {
    display: flex !important;
  }
  .custom-message {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
</style>
<style>
.mobile-message-box {
  width: 80% !important; /* 设置宽度为屏幕宽度的 80% */
  max-width: 300px; /* 最大宽度 */
}
.phone-custom-message {
  top: 30% !important; /* 垂直居中 */
  left: 50% !important; /* 水平居中 */
  transform: translate(-50%, -50%) !important; /* 偏移修正 */
  width: auto !important; /* 宽度自适应 */
  min-width: 200px; /* 最小宽度 */
  text-align: center; /* 文字居中 */
}
</style>
